import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1c200730"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c200730')) {
      api.createRecord('1c200730', component.options)
    } else {
      api.reload('1c200730', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=1c200730", function () {
      api.rerender('1c200730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flowschemes/add.vue"
export default component.exports